import { useState } from 'react';

interface CriaaBadgeProps {
  userId: string | null;
  showBadge?: boolean;
}

export function CriaaBadge({ userId, showBadge = true }: CriaaBadgeProps) {
  const [dismissed, setDismissed] = useState(false);

  if (!showBadge || dismissed) return null;

  const bgStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
  } as React.CSSProperties;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 10,
        right: 10,
        zIndex: 50,
        display: 'flex',
        flexDirection: 'row' as const,
        alignItems: 'stretch',
        gap: 1,
        pointerEvents: 'auto',
      }}
    >
      <a
        href="https://criaaa.com"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          ...bgStyle,
          height: 18,
          padding: '0 8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 11,
          fontWeight: 400,
          color: '#ffffff',
          textDecoration: 'none',
          whiteSpace: 'nowrap',
          lineHeight: 1,
        }}
      >
        Feito com CRIAAA
      </a>
      <button
        onClick={() => setDismissed(true)}
        aria-label="Fechar badge"
        style={{
          ...bgStyle,
          width: 18,
          height: 18,
          border: 'none',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: '#ffffff',
          fontSize: 11,
          lineHeight: 1,
          fontFamily: "'IBM Plex Mono', monospace",
        }}
      >
        ✕
      </button>
    </div>
  );
}
